import { useState } from "react";
import { Link } from "react-router-dom";

function Header({ page }) {
    const [isOpen, setOpen] = useState(false)

    const handleClick = () => {
        setOpen(!isOpen)
    }

    let active = "text-white rounded bg-blue-700 lg:bg-transparent lg:text-blue-700 lg:p-0 dark:text-white",
        nonactive = "text-gray-700 border-b border-gray-100 hover:bg-gray-50 lg:hover:bg-transparent lg:border-0 lg:hover:text-blue-700 lg:p-0 dark:text-gray-400 lg:dark:hover:text-white dark:hover:bg-gray-700 dark:hover:text-white lg:dark:hover:bg-transparent dark:border-gray-700"


    return (
        <header>
            <nav class="sm:w-11/12 w-full mt-4 mx-auto border-gray-200 px-2 md:px-4 lg:px-6 py-2.5  rounded-b-lg">
                <div class="flex flex-wrap justify-between items-center mx-auto max-w-screen-xl">
                    <Link to="/">
                        <div class="flex items-center">
                            <span class="self-center text-xl font-semibold whitespace-nowrap dark:text-white">Disconomy</span>
                        </div>
                    </Link>
                    <div class="flex items-center lg:order-2">
                        <Link to="/app">
                            <button className="font-medium rounded-md text-sm px-4 lg:px-5 py-2 lg:py-2.5 mr-2 focus:outline-none focus:ring-2 text-white focus:ring-indigo-700 focus:ring-opacity-50 bg-indigo-600 justify-center text-whitetransition-all duration-200 cursor-pointer hover:bg-indigo-700 hover:shadow-xl active:shadow-none">
                                Uygulamaya gir
                            </button>
                        </Link>
                        <button onClick={handleClick} type="button" class="transition inline-flex items-center p-2 ml-1 text-sm text-gray-500 rounded-lg lg:hidden hover:bg-gray-100 focus:outline-none dark:text-gray-400 dark:hover:bg-gray-700" >
                            <span class="sr-only">Open main menu</span>
                            <svg class={`${isOpen ? "hidden" : ""} w-6 h-6`} fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M3 5a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 10a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 15a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1z" clip-rule="evenodd"></path></svg>
                            <svg class={`${isOpen ? "" : "hidden"} w-6 h-6`} fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd"></path></svg>
                        </button>
                    </div>
                    <div class={`${isOpen ? "" : "hidden"} transition justify-between items-center w-full lg:flex lg:w-auto lg:order-1`} id="mobile-menu-2">
                        <ul class="flex flex-col mt-4 font-lg font-normal lg:flex-row lg:space-x-8 lg:mt-0">
                            <li>
                                <Link to="/">
                                    <span class={`block py-2 pr-4 pl-3 ${page === "home" ? active : nonactive}`}>
                                        Anasayfa
                                    </span>
                                </Link>
                            </li>
                            <li>
                                <Link to="/discover">
                                    <span class={`block py-2 pr-4 pl-3 ${page === "discover" ? active : nonactive}`}>
                                        Keşfet
                                    </span>
                                </Link>
                            </li>
                            <li>
                                <Link to="/ranking">
                                    <span class={`block py-2 pr-4 pl-3 ${page === "ranking" ? active : nonactive}`}>
                                        Sıralamalar
                                    </span>
                                </Link>
                            </li>
                            <li>
                                <Link to="/privacy">
                                    <span class={`block py-2 pr-4 pl-3 ${page === "privacy" ? active : nonactive}`}>
                                        Gizlilik Politikası
                                    </span>
                                </Link>
                            </li>
                            <li>
                                <Link to="/tos">
                                    <span class={`block py-2 pr-4 pl-3 ${page === "tos" ? active : nonactive}`}>
                                        Kullanım şartları
                                    </span>
                                </Link>
                            </li>
                            <li>
                                <Link to="/supporters">
                                    <span class={`block py-2 pr-4 pl-3 ${page === "supporters" ? active : nonactive}`} >
                                        Sponsorlar
                                    </span>
                                </Link>
                            </li>
                        </ul>
                    </div>
                </div>
            </nav>
        </header>
    )
}

export default Header;